import { useDispatch, useSelector } from 'react-redux';

import { isolatedDiscardVehicle, discardVehicleFieldsRequested } from 'Core/actions/fitmentSearch/index.js';
import { discardField } from 'Core/actions/request.js';
import {
  createResponseVehicleSelector,
  isVehicleSelectedSelector,
  fitmentSearchBaseFieldsSelector,
  fitmentSearchExtraFieldsSelector,
  fitmentSearchFieldsSelector,
} from 'Core/selectors/fitmentSearch/index.js';
import fitmentSearchConfig from 'Models/uiConfig/fitmentSearchConfig.js';
import FacetToggle from 'Components/smallComponents/facetToggle.tsx';
import { cloneSafe } from 'Utils/components.ts';

export default function VehicleLabel({
  template,
  appendedClasses,
  rootRef,
  isolatedKey,
  onChangeVehicle,
  openDialog,
  facetToggleConfig,
  globalVehicleDiscardEnabled,
  templateName,
}) {
  const dispatch = useDispatch();

  const selectedVehicle = useSelector(createResponseVehicleSelector(isolatedKey));
  const isVehicleSelected = useSelector(isVehicleSelectedSelector);
  const fitmentFields = useSelector(fitmentSearchFieldsSelector);
  const baseFitmentFields = useSelector(fitmentSearchBaseFieldsSelector);
  const extraFitmentFields = useSelector(fitmentSearchExtraFieldsSelector);

  const discardVehicle = () => {
    dispatch(discardField('Universal', { stayOnPage: true, sendRequest: false }));
    dispatch(isolatedDiscardVehicle(isolatedKey, globalVehicleDiscardEnabled));
    onChangeVehicle();
    fitmentSearchConfig.onVehicleDiscarded();
  };

  const discardFields = (fields) =>
    dispatch(discardVehicleFieldsRequested(isolatedKey, fitmentFields, fields));

  const facetToggle = (templ) => {
    if (!facetToggleConfig) {
      return null;
    }

    const props = {
      template: templ,
      key: 'facet-toggle',
      ...facetToggleConfig,
    };

    return <FacetToggle {...props} />;
  };

  const params = {
    template: templateName,
    isVehicleSelected,
    fitmentSearchTitle: fitmentSearchConfig.fitmentSearchTitle,
    vehicle: selectedVehicle.filteredFieldMap,
    vehicleString: selectedVehicle.toString(),
    vehicleBaseValues: selectedVehicle.getFilteredValues(baseFitmentFields),
    vehicleExtraValues: selectedVehicle.getFilteredValues(extraFitmentFields),
    changeVehicle: onChangeVehicle,
    discardVehicle,
    discardFields,
    facetToggle,
    openDialog,
  };
  const component = template.call(params);

  return cloneSafe(component, rootRef, { appendedClasses });
}
